<template>

  <div>
    <div style="width: 100%;">
      <img src="./banner_01.png" alt="产品与服务" style="width: 100%; height: auto;">
    </div>

    <!-- 产品服务-->
    <div class="wd100 pdtop" style="width: 1255px;margin: 40px auto;position: relative;">

      <div>
        <span style="font-size: 24px;font-weight: 800">我们的优势 <span
          style="font-size: 16px;font-weight: 600;color: #656363">our strengths</span></span>
      </div>

      <div class="container">
        <div class="item">
          <div class="imgdiv">
            <img src="./ys001.png" alt="系统安全">
          </div>
          <h3>系统安全</h3>
          <p>系统安全系统安全系统安全系统安全系统安全系统安全</p>
        </div>
        <div class="item">
          <div class="imgdiv">
            <img src="./ys002.png" alt="服务保障">
          </div>
          <h3>服务保障</h3>
          <p>服务保障服务保障服务保障服务保障服务保障服务保障</p>
        </div>
        <div class="item">
          <div class="imgdiv">
            <img src="./ys003.png" alt="质量保优">
          </div>
          <h3>质量保优</h3>
          <p>质量保优质量保优质量保优质量保优质量保优质量保优</p>
        </div>
        <div class="item">
          <div class="imgdiv">
            <img src="./ys004.png" alt="一站式服务">
          </div>
          <h3>一站式服务</h3>
          <p>一站式服务一站式服务一站式服务一站式服务一站式服务</p>
        </div>
      </div>
    </div>

    <div class="wd100 pdtop" style="width: 1255px;margin: 60px auto;position: relative;height: 2500px">
      <div>
        <span style="font-size: 24px;font-weight: 800">产品与服务 <span
          style="font-size: 16px;font-weight: 600;color: #656363">Products & solutions</span></span>
      </div>

      <!--数字化软件-->
      <div class="container0">
        <div class="image-container">
          <img src="./fuwu6.png" alt="Image Description">
        </div>
        <div class="text-container">
          <div style="height: 55px;padding-top: 30px;margin-left: 43px">
            <h1><img src="./fuwu06.png" alt="Image Description" style="position: absolute;margin-left: -51px;">数字化软件
            </h1>
          </div>
          <div
            style="height: 132px; display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 5;overflow: hidden; margin-left: 1px">
            <p style="color: #666">
              &nbsp;&nbsp; &nbsp;&nbsp;数字化软件广泛应用于企业（如ERP系统、MES生产制造系统、WMS仓库系统、CRM系统、OA系统...）、教育（如在线学习平台）、智慧公车、智慧城市、智慧医疗等领域，助力组织降本增效，增强用户体验。
            </p>
          </div>
                    <div
                      style="height: 100px; display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 4;overflow: hidden;padding-top: 5px; margin-left: 1px ">
                      <p style="color: #666">
                        &nbsp;&nbsp; &nbsp;&nbsp;利用数字技术开发的应用工具，旨在将传统业务流程转化为高效、智能的数字化形式。它通过自动化处理、数据集成和实时分析，优化管理流程，提升决策效率。
                      </p>
                    </div>
          <div style="height: 36px;margin-top: 16px; margin-left: 1px ">
            <button  class="xiangq" @click="active('/digitalsoftware')">了解详情</button>
          </div>
        </div>
      </div>

      <!--知识产权-->
      <div class="container0">
        <div class="text-container">
          <div style="height: 55px;padding-top: 30px;margin-left: 43px">
            <h1><img src="./fuwu01.png" alt="Image Description" style="position: absolute;margin-left: -51px;">知识产权
            </h1>
          </div>
          <div
            style="height: 92px; display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 4;overflow: hidden; margin-left: -1px">
            <p style="color: #666">
              &nbsp;&nbsp; &nbsp;&nbsp;公司致力于为企业提供全方位的个性化知识产权战略咨询及整体解决方案，涵盖专
              利、商标、计算机软件著作权、版权等方面的申请、注册、许可、转让、评估等服务。
            </p>
          </div>
          <div
            style="height: 140px; display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 4;overflow: hidden;padding-top: 5px; margin-left: -1px ">
            <p style="color: #666">
              &nbsp;&nbsp; &nbsp;&nbsp;公司同时为客户提供企业内部知识产权制度的建构、专利数据库的建设、专利挖掘
              申请、知识产权托管、研发人员以及高管团队的知识产权引进、培训服务。
            </p>
          </div>
          <div style="height: 36px;margin-top: 16px; margin-left: 1px ">
              <button  class="xiangq" @click="active('/intellectualProperty')">了解详情</button>
          </div>
        </div>
        <div class="image-container2">
          <img src="./fuwu1.png" alt="Image Description">
        </div>
      </div>

      <!--园区服务-->
      <div class="container0">
        <div class="image-container">
          <img src="./fuwu5.png" alt="Image Description">
        </div>
        <div class="text-container">
          <div style="height: 55px;padding-top: 30px">
            <h1><img src="./fuwu05.png" alt="Image Description" style="position: absolute;margin-left: -50px;">园区服务
            </h1>
          </div>
          <div
            style="height: 232px; display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 5;overflow: hidden; margin-left: -45px">
            <p style="color: #666">
              &nbsp;&nbsp; &nbsp;&nbsp;基于丰富的国家高技术企业培育入库、认证申报辅导经验及完整的服务体系，凭借科
              学、严谨、规范的咨询服务流程和体系，帮助园区整合外部资源，搭建园区服务科技平
              台，推动企业自身科技能力和产品升级，提高园区核心竞争力，帮助园区进行高新技术企业认定。
            </p>
          </div>
          <!--          <div-->
          <!--            style="height: 140px; display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 4;overflow: hidden;padding-top: 5px; margin-left: -45px ">-->
          <!--            <p style="color: #666">-->
          <!--              &nbsp;&nbsp; &nbsp;&nbsp;-->
          <!--            </p>-->
          <!--          </div>-->
          <div style="height: 36px;margin-top: 16px; margin-left: -45px ">
              <button  class="xiangq" @click="active('/parkServices')">了解详情</button>
          </div>
        </div>
      </div>

      <!--项目申报-->
      <div class="container0">
        <div class="text-container">
          <div style="height: 55px;padding-top: 30px;margin-left: 43px">
            <h1><img src="./fuwu03.png" alt="Image Description" style="position: absolute;margin-left: -51px;">项目申报
            </h1>
          </div>
          <div
            style="height: 232px; display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 4;overflow: hidden; margin-left: -1px">
            <p style="color: #666">
              &nbsp;&nbsp; &nbsp;&nbsp;公司专注于为湖北地区各类科技型企业、农业企业提供科技项目申报、税收优惠减
              免、知识产权申办、技术转移、成果对接等多方面的业务咨询与服务，
              全面提升企业科 项目申报技研发能力、品牌形象和市场竞争力，解决企业“项目匹配、读懂政策、申报跟进”三
              大难题，帮助企业提升政策申报的效率及成功率。

            </p>
          </div>
          <div style="height: 36px;margin-top: 16px; margin-left: 1px ">
              <button  class="xiangq" @click="active('/projectApplication')">了解详情</button>
          </div>
        </div>
        <div class="image-container2">
          <img src="./fuwu3.png" alt="Image Description">
        </div>
      </div>

      <!--资质认定-->
      <div class="container0">
        <div class="image-container2">
          <img src="./fuwu2.png" alt="Image Description">
        </div>
        <div class="text-container">
          <div style="height: 55px;padding-top: 30px;margin-left: 43px">
            <h1><img src="./fuwu02.png" alt="Image Description" style="position: absolute;margin-left: -51px;">资质认定
            </h1>
          </div>
          <div
            style="height: 92px; display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 4;overflow: hidden; margin-left: 1px">
            <p style="color: #666">
              &nbsp;&nbsp; &nbsp;&nbsp;积极响应政府倡导和政策指引，始终密切关注质量提升和社会消费的趋势，牢固坚
              持客户至上的服务宗旨，潜心致力于通过认证帮助客户提高产品和服务质量，促成各界
              的交流与合作，促进市场诚信体系与和谐社会建设。
            </p>
          </div>
          <div
            style="height: 140px; display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 4;overflow: hidden;padding-top: 5px; margin-left: 1px ">
            <p style="color: #666">
              &nbsp;&nbsp; &nbsp;&nbsp;经过不断的发展，专注于成为业务门类全、服务网络广、技术力量强的一流质量服
              务机构，以较高的信誉度和美誉度路身知名认证品牌行列。朝着社会公信力高，有较强
              创新能力、市场竞争能力和可持续发展能力的全球认证机构的目标大步迈进。
            </p>
          </div>
          <div style="height: 36px;margin-top: 16px; margin-left: 1px ">
              <button  class="xiangq" @click="active('/qualifications')">了解详情</button>
          </div>
        </div>
      </div>

      <!--财务审计-->
      <div class="container0">
        <div class="text-container">
          <div style="height: 55px;padding-top: 30px;margin-left: 43px">
            <h1><img src="./fuwu04.png" alt="Image Description" style="position: absolute;margin-left: -51px;">财务审计
            </h1>
          </div>
          <div
            style="height: 232px; display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 5;overflow: hidden; margin-left: 1px">
            <p style="color: #666">
              &nbsp;&nbsp; &nbsp;&nbsp;专注于对企业财务和税务状况进行的独立检查，旨在确保财务信息的真实性、准确站式财税服务性和税务合规性。
              服务涵盖财务报表审计、税务合规审计、内部控制评估及风险管理，
              帮助企业识别潜在问题，降低经营和税务风险，优化财税管理。通过审计，
              企业可提升商注册+代理记账+财税咨询透明度和信任度，保护声誉，为决策提供支持。
            </p>
          </div>
          <div style="height: 36px;margin-top: 16px; margin-left: 1px ">
              <button  class="xiangq" @click="active('/financialAudit')">了解详情</button>
          </div>
        </div>
        <div class="image-container2">
          <img src="./fuwu4.png" alt="Image Description">
        </div>
      </div>

    </div>

<!--    &lt;!&ndash;合作客户&ndash;&gt;-->
<!--    <div class="wd100 pdtop" style="width: 1255px;margin: 60px auto;position: relative;z-index: 9999;height: 300px">-->
<!--      <div>-->
<!--        <span style="font-size: 24px;font-weight: 800">合作客户 <span-->
<!--          style="font-size: 16px;font-weight: 600;color: #656363">Partner</span></span>-->
<!--      </div>-->

<!--      <div class="partners">-->
<!--        <div class="partner-item">-->
<!--          <img src="./partner1.png" alt="Partner 1">-->
<!--          <p>土家牧业</p>-->
<!--        </div>-->
<!--        <div class="partner-item">-->
<!--          <img src="./partner2.png" alt="Partner 2">-->
<!--          <p>勤隆</p>-->
<!--        </div>-->
<!--        <div class="partner-item">-->
<!--          <img src="./partner3.png" alt="Partner 3">-->
<!--          <p>利川百姓网</p>-->
<!--        </div>-->
<!--        <div class="partner-item">-->
<!--          <img src="./partner4.png" alt="Partner 4">-->
<!--          <p>Transl</p>-->
<!--        </div>-->
<!--        <div class="partner-item">-->
<!--          <img src="./partner5.png" alt="Partner 5">-->
<!--          <p>湖北省金贝嘉天然农业股份有限公司</p>-->
<!--        </div>-->
<!--      </div>-->

<!--      <div class="partners">-->
<!--        <div class="partner-item">-->
<!--          <img src="./partner1.png" alt="Partner 1">-->
<!--          <p>土家牧业</p>-->
<!--        </div>-->
<!--        <div class="partner-item">-->
<!--          <img src="./partner2.png" alt="Partner 2">-->
<!--          <p>勤隆</p>-->
<!--        </div>-->
<!--        <div class="partner-item">-->
<!--          <img src="./partner3.png" alt="Partner 3">-->
<!--          <p>利川百姓网</p>-->
<!--        </div>-->
<!--        <div class="partner-item">-->
<!--          <img src="./partner4.png" alt="Partner 4">-->
<!--          <p>Transl</p>-->
<!--        </div>-->
<!--        <div class="partner-item">-->
<!--          <img src="./partner5.png" alt="Partner 5">-->
<!--          <p>湖北省金贝嘉天然农业股份有限公司</p>-->
<!--        </div>-->
<!--      </div>-->

<!--      <div class="partners">-->
<!--        <div class="partner-item">-->
<!--          <img src="./partner1.png" alt="Partner 1">-->
<!--          <p>土家牧业</p>-->
<!--        </div>-->
<!--        <div class="partner-item">-->
<!--          <img src="./partner2.png" alt="Partner 2">-->
<!--          <p>勤隆</p>-->
<!--        </div>-->
<!--        <div class="partner-item">-->
<!--          <img src="./partner3.png" alt="Partner 3">-->
<!--          <p>利川百姓网</p>-->
<!--        </div>-->
<!--        <div class="partner-item">-->
<!--          <img src="./partner4.png" alt="Partner 4">-->
<!--          <p>Transl</p>-->
<!--        </div>-->
<!--        <div class="partner-item">-->
<!--          <img src="./partner5.png" alt="Partner 5">-->
<!--          <p>湖北省金贝嘉天然农业股份有限公司</p>-->
<!--        </div>-->
<!--      </div>-->

<!--      <div class="partners">-->
<!--        <div class="partner-item">-->
<!--          <img src="./partner1.png" alt="Partner 1">-->
<!--          <p>土家牧业</p>-->
<!--        </div>-->
<!--        <div class="partner-item">-->
<!--          <img src="./partner2.png" alt="Partner 2">-->
<!--          <p>勤隆</p>-->
<!--        </div>-->
<!--        <div class="partner-item">-->
<!--          <img src="./partner3.png" alt="Partner 3">-->
<!--          <p>利川百姓网</p>-->
<!--        </div>-->
<!--        <div class="partner-item">-->
<!--          <img src="./partner4.png" alt="Partner 4">-->
<!--          <p>Transl</p>-->
<!--        </div>-->
<!--        <div class="partner-item">-->
<!--          <img src="./partner5.png" alt="Partner 5">-->
<!--          <p>湖北省金贝嘉天然农业股份有限公司</p>-->
<!--        </div>-->
<!--      </div>-->



<!--    </div>-->

    <div class="wd100 pdtop" style="width: 1255px;margin: 0px auto;height:300px">
    </div>
  </div>


</template>
<style scoped>
@import 'productAndService.css';
</style>
<script>
import {save} from '@/api/common'

export default {
  components: {},
  data() {
    return {
      teachers: [],
    }
  },

  methods: {   active(url) {
      this.$router.push(url);
    },},
  mounted: function () {
    // 获取所有按钮
    const buttons = document.querySelectorAll('.header span');

    // 遍历每个按钮并添加点击事件
    buttons.forEach(button => {
      button.addEventListener('click', () => {
        // 移除所有按钮的 active 类
        buttons.forEach(btn => btn.classList.remove('active'));
        // 给当前点击的按钮添加 active 类
        button.classList.add('active');
      });
    });
  },
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/pages/productAndService/productAndService.vue